import styled from '@emotion/styled';
import React, { useState } from 'react';
import { Modal } from 'antd';
import {
  InfoModalContent,
  InfoModalHeader,
  InfoModalIcon,
  InfoModalBody,
  InfoModalText,
  InfoModalTitle,
  InfoModalFooter,
  InfoModalPrimaryButton,
  ModalCloseButton,
} from '../../../../ProjectFormV2/components/Promotions/Modal.styles';
// removed unused imports
import { CloseOutlined } from '@ant-design/icons';
import BlueCheck from '../../../../ProjectFormV2/components/PersonalInformation/Icons/BlueCheck';
import ReceiptCheck from '../DetailComponents/Icons/ReceiptCheck';
export default function CheckMarkModal({ badgeSize, hasOrganization }) {

  const [showModal, setShowModal] = useState(false);
  const [innerWidth, setInnerWidth] = React.useState(window?.innerWidth || 0);
  const [tooltipPosition, setTooltipPosition] = React.useState(null);
  const tooltipContainerRef = React.useRef(null);
  const badgeRef = React.useRef(null);

  React.useEffect(() => {
    const handleResize = () => setInnerWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  function onClose() {
    setShowModal(false);
  }

  const positionTooltip = React.useCallback(() => {
    if (!tooltipContainerRef.current || !badgeRef.current) return;

    const containerRect = tooltipContainerRef.current.getBoundingClientRect();
    const badgeRect = badgeRef.current.getBoundingClientRect();
    const viewportPadding = 16;
    const tooltipWidth = Math.min(192, window.innerWidth - viewportPadding * 2);
    const badgeCenter = badgeRect.left + badgeRect.width / 2;
    const viewportLeft = Math.min(
      Math.max(badgeCenter - tooltipWidth / 2, viewportPadding),
      window.innerWidth - tooltipWidth - viewportPadding
    );

    setTooltipPosition({
      left: viewportLeft - containerRect.left,
      arrowLeft: badgeCenter - viewportLeft,
    });
  }, []);

  return (
    <>
      <TooltipContainer
        ref={tooltipContainerRef}
        onMouseEnter={positionTooltip}
        onFocus={positionTooltip}
        $positioned={tooltipPosition !== null}
      >
        <LogoBadge
          ref={badgeRef}
          onClick={() => setShowModal(true)}
          $size={badgeSize}
        >
          {hasOrganization ? <BlueCheck /> : <ReceiptCheck />}
        </LogoBadge>

        <TooltipBox
          className="cp-tooltip"
          role="tooltip"
          $left={tooltipPosition?.left}
        >
          <TooltipTitle>
            {hasOrganization
              ? 'Verifizierte Organisation'
              : 'Ausweisdokument hinterlegt'}
          </TooltipTitle>
          <TooltipSupporting onClick={() => setShowModal(true)}>
            Weitere Informationen
          </TooltipSupporting>
          <TooltipArrow $left={tooltipPosition?.arrowLeft} />
        </TooltipBox>
      </TooltipContainer>
      <Modal
        open={showModal}
        onCancel={onClose}
        footer={null}
        width={600}
        closable={false}
        style={{
          marginTop: innerWidth < 1400 ? 0 : undefined,
          top: innerWidth < 1400 ? 0 : undefined,
        }}
        bodyStyle={{ padding: 0 }}
      >
        {' '}
        <InfoModalContent>
          <InfoModalHeader></InfoModalHeader>

          <InfoModalBody>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignContent: 'center', alignItems: 'center'}}>
              <InfoModalIcon>
                <BlueCheck />
              </InfoModalIcon>
              <ModalCloseButton onClick={onClose}>
                <CloseOutlined />
              </ModalCloseButton>
            </div>
            <InfoModalTitle>
              Was bedeutet das commonsplace-Siegel?
            </InfoModalTitle>
            <InfoModalText>
              Um Vertrauen zu schaffen, prüft commonsplace bestimmte Angaben von
              Projektinitiatoren wie private Initiativen oder Organisationen.{' '}
              <br />
              <br />
              <strong>
                So kannst du besser einschätzen, mit wem du es zu tun hast und
                wem du deine Sadaqah anvertraust.
              </strong>
            </InfoModalText>
            <InfoModalTitle>(Gemeinnützige) Organisationen</InfoModalTitle>
            <InfoModalText>
              Wenn eine Organisation dieses Siegel trägt, hat commonsplace ihre
              Echtheit überprüft und bestätigt, dass es sich um eine offiziell
              registrierte (gemeinnützige) Organisation handelt.
            </InfoModalText>
            <InfoModalTitle>Personen mit Namen</InfoModalTitle>

            <InfoModalText>
              Wenn eine Person ihren echten Namen angibt und dieses Siegel
              trägt, hat sie ein offizielles Ausweisdokument (z. B.
              Personalausweis oder Pass) bei commonsplace hinterlegt.
            </InfoModalText>
            <InfoModalTitle>Anonyme Personen</InfoModalTitle>

            <InfoModalText>
              Auch wenn jemand anonym bleiben möchte, müssen Ausweisdokumente
              bei commonsplace hinterlegt sein. Daher tragen auch anonyme
              Profile automatisch ein Siegel – selbst wenn der Name nicht
              angezeigt wird.*
            </InfoModalText>

            <InfoModalText>
              <small>
                *commonsplace prüft die vorliegenden Dokumente sorgfältig, kann
                jedoch keine Garantie für Vollständigkeit oder Richtigkeit
                übernehmen.
              </small>
            </InfoModalText>

            {/*<InfoModalPrimaryLink style={{ display: 'block', marginTop: '16px' }}>*/}
            {/*  Weitere Details finden sich im Infoblatt (PDF).*/}
            {/*</InfoModalPrimaryLink>*/}
          </InfoModalBody>

          <InfoModalFooter>
            <InfoModalPrimaryButton onClick={onClose}>
              Verstanden
            </InfoModalPrimaryButton>
          </InfoModalFooter>
        </InfoModalContent>
      </Modal>
    </>
  );

}


const LogoBadge = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const TooltipContainer = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  display: inline-block;

  /* increase hit area so a small gap between badge and tooltip doesn't close it */
  padding-bottom: 20px;

  /* show tooltip when hovering the container OR the tooltip itself (prevents closing when moving mouse between badge and tooltip) */
  &:hover .cp-tooltip,
  & .cp-tooltip:hover {
    opacity: 1;
    visibility: visible;
    /* keep the user's requested hover transform */
    transform: ${({ $positioned }) =>
      $positioned ? 'translateY(0)' : 'translateX(-50%) translateY(0)'};
    pointer-events: auto;
  }

  /* Keep the badge and tooltip above project content, but below fixed headers. */
  z-index: 10;
`;

const TooltipBox = styled.div`
  position: absolute;
  /* place tooltip below the badge */
  top: calc(100% + 8px);
  left: ${({ $left }) => ($left == null ? '50%' : `${$left}px`)};
  /* start slightly above final position and slide down on hover, slightly left offset */
  /* initial: further up; hover moves it down a bit (but still above original) */
  transform: ${({ $left }) =>
    $left == null
      ? 'translateX(calc(-50% - 8px)) translateY(-12px)'
      : 'translateY(-12px)'};
  width: 192px;
  box-sizing: border-box;
  padding: 12px;
  background: #0A0D12;
  border-radius: 8px;
  box-shadow: 0px 12px 16px -4px rgba(10, 13, 18, 0.08), 0px 4px 6px -2px rgba(10, 13, 18, 0.03), 0px 2px 2px -1px rgba(10, 13, 18, 0.04);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  opacity: 0;
  visibility: hidden;
  transition: opacity 160ms ease, transform 160ms ease;
  pointer-events: none;
  z-index: 1001;
  overflow: visible;

  @media (max-width: 767px) {
    width: 192px;
    max-width: calc(100vw - 32px);
  }
`;

const TooltipTitle = styled.div`
  width: 100%;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: #ffffff;
`;

const TooltipSupporting = styled.div`
  width: 100%;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: #D5D7DA;
  text-decoration-line: underline;
  cursor: pointer;
`;

const TooltipArrow = styled.div`
  position: absolute;
  width: 12px;
  height: 12px;
  left: ${({ $left }) => ($left == null ? '50%' : `${$left}px`)};
  transform: ${({ $left }) =>
    $left == null
      ? 'translateX(calc(-50% - 8px)) rotate(45deg)'
      : 'translateX(-50%) rotate(45deg)'};
  /* place arrow at top of tooltip so it points upward to the badge */
  top: -4px;
  background: #0A0D12;
  border-radius: 1px;
  box-shadow: 0px -6px 8px -6px rgba(10, 13, 18, 0.08);
  z-index: 1000;

`;
